import { useEffect, useState } from "react";
import { api } from "@/api";

const isDirectSource = (source) => /^(https?:|data:|blob:|\/)/i.test(source || "");

export default function ProtectedImage({ src, alt, className = "", compact = false, ...props }) {
  const [resolvedSrc, setResolvedSrc] = useState(null);

  useEffect(() => {
    let objectUrl;
    let alive = true;

    if (!src) {
      setResolvedSrc(null);
      return undefined;
    }
    if (isDirectSource(src)) {
      setResolvedSrc(src);
      return undefined;
    }

    setResolvedSrc(null);
    api.get(`/files/${src}`, { responseType: "blob" })
      .then(({ data }) => {
        if (!alive) return;
        objectUrl = URL.createObjectURL(data);
        setResolvedSrc(objectUrl);
      })
      .catch(() => {
        if (alive) setResolvedSrc(null);
      });

    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  // Fallback jujur: eksplisit bukan foto pengganti; netral di kedua theme.
  // Varian compact untuk thumb kecil (teks satu baris, tidak mendesak isi).
  if (!resolvedSrc) {
    return (
      <div
        role="img"
        aria-label={alt ? `Belum ada foto untuk ${alt}` : "Belum ada foto"}
        className={`${className} flex flex-col items-center justify-center gap-1 overflow-hidden bg-slate-500/10 p-3 text-center text-xs text-slate-500`}
        {...props}
      >
        {compact ? (
          <span>Belum ada foto</span>
        ) : (
          <>
            <span aria-hidden="true">◌</span>
            <span>Belum ada foto. Gambar menyusul, bukan foto pengganti.</span>
          </>
        )}
      </div>
    );
  }

  return <img src={resolvedSrc} alt={alt} className={className} {...props} />;
}
